<template>
  <v-container fluid>
    <p class="neutral--text text-semi-bold mb-0">{{ $t('provider-info-message') }}</p>
    <p id="your-process" class="mb-0 pt-2 primary200--text">{{ $t('your-progress') }}</p>
    <p id="progress-number" class="text-semi-bold primary300--text mb-1">
      {{ tab }}/{{ totalTabs }} {{ $t('to-complete') }}
    </p>
    <v-progress-linear
      v-model="progress"
      color="primary300"
      id="provider-progress-bar"
      class="mb-5"
      height="25"
    ></v-progress-linear>
    <v-tabs v-model="tab" show-arrows :class="'disable-transition'">
      <v-tabs-slider color="primary200"></v-tabs-slider>
      <v-tab>{{ $t('basic') }}</v-tab>
      <v-tab>{{ $t('marketing') }}</v-tab>
      <v-tab>{{ $t('classification') }}</v-tab>
      <v-tab>{{ $t('contact') }}</v-tab>
      <v-tab>{{ $t('location') }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item :transition="false" :reverse-transition="false" :key="1">
        <v-row>
          <v-col cols="12">
            <provider-basic-info :next="true" @tab="changeTab"></provider-basic-info>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false" :key="2">
        <v-row>
          <v-col cols="12">
            <provider-marketing-info :next="true" @tab="changeTab"></provider-marketing-info>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false" :key="3">
        <v-row>
          <v-col cols="12">
            <provider-classification-info
              :next="true"
              @tab="changeTab"
            ></provider-classification-info>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false" :key="4">
        <v-row>
          <v-col cols="12">
            <provider-contact-info :next="true" @tab="changeTab"></provider-contact-info>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item :transition="false" :reverse-transition="false" :key="5">
        <v-row>
          <v-col cols="12">
            <provider-location-info :next="true" @tab="changeTab"></provider-location-info>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import ProviderBasicInfo from '@/components/provider-settings/ProviderBasicInfo.vue';
import ProviderMarketingInfo from '@/components/provider-settings/ProviderMarketingInfo';
import ProviderLocationInfo from '@/components/provider-settings/ProviderLocationInfo';
import ProviderContactInfo from '@/components/provider-settings/ProviderContactInfo';
import ProviderClassificationInfo from '@/components/provider-settings/ProviderClassificationInfo';

export default {
  name: 'ProviderSettings',
  components: {
    ProviderClassificationInfo,
    ProviderContactInfo,
    ProviderLocationInfo,
    ProviderMarketingInfo,
    ProviderBasicInfo,
  },
  data() {
    return {
      tab: null,
      totalTabs: 5,
    };
  },
  methods: {
    changeTab(payload) {
      console.log('[Tab] Tab changed');
      console.log(payload);
      this.tab = payload;
    },
  },
  computed: {
    progress() {
      return (this.tab / this.totalTabs) * 100;
    },
  },
};
</script>
